// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AccordionsTab from "@eisinc/App/Widgets/DesignSystem/Components/AccordionsTab";
import BreadcrumbsTab from "@eisinc/App/Widgets/DesignSystem/Components/BreadcrumbsTab";
import ButtonsTab from "@eisinc/App/Widgets/DesignSystem/Components/ButtonsTab";
import ColorsTab from "@eisinc/App/Widgets/DesignSystem/Components/ColorsTab";
import CommonTab from "@eisinc/App/Widgets/DesignSystem/Components/CommonTab";
import FormTab from "@eisinc/App/Widgets/DesignSystem/Components/FormTab";
import IconsTab from "@eisinc/App/Widgets/DesignSystem/Components/IconsTab";
import ModalTab from "@eisinc/App/Widgets/DesignSystem/Components/ModalTab";
import NotifyTab from "@eisinc/App/Widgets/DesignSystem/Components/NotifyTab";
import PaginationTab from "@eisinc/App/Widgets/DesignSystem/Components/PaginationTab";
import TableTab from "@eisinc/App/Widgets/DesignSystem/Components/TableTab";
import TabsTab from "@eisinc/App/Widgets/DesignSystem/Components/TabsTab";
import ToastTab from "@eisinc/App/Widgets/DesignSystem/Components/ToastTab";
import TooltipTab from "@eisinc/App/Widgets/DesignSystem/Components/TooltipTab";
import TypographyTab from "@eisinc/App/Widgets/DesignSystem/Components/TypographyTab";
import { XNGAGE_ELEMENTS } from "@eisinc/XDL/constants";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Tab from "@insite/mobius/Tab/Tab";
import TabGroup from "@insite/mobius/TabGroup/TabGroup";
import React, { FC } from "react";

const tabs = [
    {
        headline: "Colors",
        component: <ColorsTab />,
    },
    {
        headline: "Typography",
        component: <TypographyTab />,
    },
    {
        headline: "Icons",
        component: <IconsTab />,
    },
    {
        headline: "Buttons",
        component: <ButtonsTab />,
    },
    {
        headline: "Form",
        component: <FormTab />,
    },
    {
        headline: "Table",
        component: <TableTab />,
    },
    {
        headline: "Tabs",
        component: <TabsTab />,
    },
    {
        headline: "Tooltip",
        component: <TooltipTab />,
    },
    {
        headline: "Accordions",
        component: <AccordionsTab />,
    },
    {
        headline: "Toast",
        component: <ToastTab />,
    },
    {
        headline: "Notify",
        component: <NotifyTab />,
    },
    {
        headline: "Breadcrumbs",
        component: <BreadcrumbsTab />,
    },
    {
        headline: "Common",
        component: <CommonTab />,
    },
    {
        headline: "Modal",
        component: <ModalTab />,
    },
    {
        headline: "Pagination",
        component: <PaginationTab />,
    },
];

const initialTabGroup = "Colors";
const DesignSystem: FC = () => {
    return (
        <TabGroup current={initialTabGroup}>
            {tabs.map(tab => (
                <Tab key={tab.headline} headline={tab.headline} tabKey={tab.headline}>
                    {tab.component}
                </Tab>
            ))}
        </TabGroup>
    );
};

const widgetModule: WidgetModule<FieldDefinition> = {
    component: DesignSystem,
    definition: {
        group: "Design System" as any,
        icon: "DesignSystem",
    },
};

export default widgetModule;
